import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between mb-6" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "space-y-4 mb-8" }
const _hoisted_4 = {
  key: 0,
  class: "bg-white rounded-xl border border-gray-200 p-6 animate-pulse"
}
const _hoisted_5 = {
  key: 1,
  class: "bg-white rounded-xl border border-gray-200 p-12 text-center"
}
const _hoisted_6 = { class: "flex items-start justify-between gap-4" }
const _hoisted_7 = { class: "min-w-0 flex-1" }
const _hoisted_8 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_9 = { class: "text-sm text-gray-900 font-mono break-all" }
const _hoisted_10 = { class: "text-xs text-gray-500 mb-3" }
const _hoisted_11 = { class: "flex items-center gap-2" }
const _hoisted_12 = {
  key: 0,
  class: "text-xs font-mono bg-gray-100 px-2 py-1 rounded break-all"
}
const _hoisted_13 = {
  key: 1,
  class: "text-xs font-mono bg-gray-100 px-2 py-1 rounded"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "flex items-center gap-2 flex-shrink-0" }
const _hoisted_16 = ["onClick", "disabled"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" }
const _hoisted_20 = { class: "overflow-x-auto" }
const _hoisted_21 = { class: "w-full" }
const _hoisted_22 = { class: "divide-y divide-gray-200" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "px-6 py-4" }
const _hoisted_25 = { class: "text-sm text-gray-900" }
const _hoisted_26 = { class: "px-6 py-4" }
const _hoisted_27 = { class: "px-6 py-4 text-sm text-gray-600" }
const _hoisted_28 = { class: "px-6 py-4 text-sm text-gray-600" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 1,
  class: "text-red-600 text-xs"
}
const _hoisted_31 = { key: 2 }
const _hoisted_32 = { class: "px-6 py-4 text-sm text-gray-600" }
const _hoisted_33 = { class: "px-6 py-4" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto" }
const _hoisted_36 = { class: "p-6 border-b border-gray-200 flex items-center justify-between" }
const _hoisted_37 = ["placeholder"]
const _hoisted_38 = {
  key: 0,
  class: "text-xs text-gray-500 mt-2"
}
const _hoisted_39 = { class: "space-y-2 max-h-52 overflow-y-auto border border-gray-200 rounded-lg p-3" }
const _hoisted_40 = ["value"]
const _hoisted_41 = { class: "text-xs text-gray-700" }
const _hoisted_42 = {
  key: 0,
  class: "bg-red-50 border border-red-200 rounded-lg p-3"
}
const _hoisted_43 = { class: "text-sm text-red-600" }
const _hoisted_44 = { class: "flex gap-3 pt-2" }
const _hoisted_45 = ["disabled"]

import { ref, onMounted } from 'vue'
import { Icon } from '@iconify/vue'
import { apiFor, isEnvironmentUnauthorized } from '../services/api'
import EnvironmentUnavailable from '../components/EnvironmentUnavailable.vue'
import { useModeStore } from '../store/mode'
import { useAuthStore } from '../store/auth'
import { useNotification } from '../composables/useNotification'
import { EVENT_TYPES } from '../services/events'


export default /*@__PURE__*/_defineComponent({
  __name: 'WebhooksView',
  setup(__props) {

const modeStore = useModeStore()
const authStore = useAuthStore()
const notify = useNotification()

const endpoints = ref<any[]>([])
const deliveries = ref<any[]>([])
const loading = ref(true)
const envUnavailable = ref(false)
const showModal = ref(false)
const saving = ref(false)
const error = ref('')
const testingId = ref('')
const visibleSecrets = ref<Record<string, boolean>>({})

const form = ref({ url: '', events: [] as string[] })

onMounted(() => {
  load()
  loadDeliveries()
})

async function load() {
  loading.value = true
  try {
    const { data } = await apiFor(modeStore.mode).get('/partner-portal/webhook-endpoints')
    endpoints.value = data.endpoints || []
  } catch (err) {
    envUnavailable.value = isEnvironmentUnauthorized(err)
    console.error('Erreur chargement endpoints:', err)
    endpoints.value = []
  } finally {
    loading.value = false
  }
}

async function loadDeliveries() {
  try {
    const { data } = await apiFor(modeStore.mode).get('/partner-portal/webhook-deliveries', {
      params: { limit: 20 },
    })
    deliveries.value = data.deliveries || []
  } catch (err) {
    console.error('Erreur chargement journal:', err)
    deliveries.value = []
  }
}

function openCreate() {
  form.value = { url: '', events: [] }
  error.value = ''
  showModal.value = true
}

async function create() {
  saving.value = true
  error.value = ''
  try {
    await apiFor(modeStore.mode).post('/partner-portal/webhook-endpoints', form.value)
    showModal.value = false
    notify.success('Endpoint créé')
    await load()
  } catch (err: any) {
    error.value = err.response?.data?.message || 'Erreur lors de la création'
  } finally {
    saving.value = false
  }
}

async function toggleActive(ep: any) {
  try {
    await apiFor(modeStore.mode).patch(`/partner-portal/webhook-endpoints/${ep.id}`, {
      active: !ep.active,
    })
    await load()
  } catch (err: any) {
    notify.error(err.response?.data?.message || 'Erreur')
  }
}

async function remove(ep: any) {
  if (!window.confirm(`Supprimer l'endpoint ${ep.url} ? Vous ne recevrez plus ses événements.`)) {
    return
  }
  try {
    await apiFor(modeStore.mode).delete(`/partner-portal/webhook-endpoints/${ep.id}`)
    notify.success('Endpoint supprimé')
    await load()
  } catch (err: any) {
    notify.error(err.response?.data?.message || 'Erreur')
  }
}

async function testEndpoint(ep: any) {
  testingId.value = ep.id
  try {
    const { data } = await apiFor(modeStore.mode).post(
      `/partner-portal/webhook-endpoints/${ep.id}/test`
    )
    if (data.delivery?.status === 'SUCCESS') {
      notify.success(data.message)
    } else {
      notify.error(data.message)
    }
    await loadDeliveries()
  } catch (err: any) {
    notify.error(err.response?.data?.message || 'Erreur lors du test')
  } finally {
    testingId.value = ''
  }
}

async function retry(w: any) {
  try {
    const { data } = await apiFor(modeStore.mode).post(
      `/partner-portal/webhook-deliveries/${w.id}/retry`
    )
    if (data.delivery?.status === 'SUCCESS') {
      notify.success('Renvoi réussi')
    } else {
      notify.warning(`Renvoi échoué : ${data.delivery?.lastError || 'erreur inconnue'}`)
    }
    await loadDeliveries()
  } catch (err: any) {
    notify.error(err.response?.data?.message || 'Erreur')
  }
}

function deliveryStatusLabel(status: string): string {
  return (
    {
      PENDING: 'En attente',
      SUCCESS: 'Reçu',
      FAILED: 'Échec (rejeu prévu)',
      EXHAUSTED: 'Abandonné',
    } as Record<string, string>
  )[status] || status
}

function deliveryStatusClass(status: string): string {
  return (
    {
      PENDING: 'bg-gray-100 text-gray-800',
      SUCCESS: 'bg-green-100 text-green-800',
      FAILED: 'bg-amber-100 text-amber-800',
      EXHAUSTED: 'bg-red-100 text-red-800',
    } as Record<string, string>
  )[status] || 'bg-gray-100 text-gray-800'
}

function formatDate(value: string): string {
  return new Intl.DateTimeFormat('fr-FR', {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(value))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (envUnavailable.value)
      ? (_openBlock(), _createBlock(EnvironmentUnavailable, {
          key: 0,
          class: "mb-6"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-sm text-gray-600 max-w-2xl" }, [
        _createTextVNode(" Youdégo appelle vos URL en HTTP POST à chaque événement, avec une signature "),
        _createElementVNode("code", { class: "text-xs bg-gray-100 px-1.5 py-0.5 rounded" }, "X-Youdego-Signature"),
        _createTextVNode(". Un envoi qui échoue est rejoué automatiquement (1 min, 5 min, 30 min, 2 h, 12 h). ")
      ], -1)),
      _createElementVNode("button", {
        onClick: openCreate,
        disabled: _unref(authStore).isSuspended,
        class: "px-4 py-2 bg-[#8C0004] text-white rounded-lg text-sm font-medium hover:bg-red-900 disabled:opacity-50 flex items-center gap-2 flex-shrink-0"
      }, [
        _createVNode(_unref(Icon), {
          icon: "solar:add-circle-bold",
          class: "w-4 h-4"
        }),
        _cache[5] || (_cache[5] = _createTextVNode(" Nouvel endpoint ", -1))
      ], 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("div", { class: "h-4 bg-gray-100 rounded w-1/3" }, null, -1)
          ]))]))
        : (endpoints.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_unref(Icon), {
                icon: "solar:bell-bold",
                class: "w-10 h-10 text-gray-300 mx-auto mb-3"
              }),
              _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-gray-500" }, "Aucun endpoint configuré dans cet environnement.", -1))
            ]))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(endpoints.value, (ep) => {
              return (_openBlock(), _createElementBlock("div", {
                key: ep.id,
                class: "bg-white rounded-xl border border-gray-200 shadow-sm p-5"
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", {
                        class: _normalizeClass([
                  'px-2 py-0.5 rounded-full text-xs font-semibold',
                  ep.active ? 'bg-emerald-100 text-emerald-800' : 'bg-gray-200 text-gray-600'
                ])
                      }, _toDisplayString(ep.active ? 'Actif' : 'Désactivé'), 3),
                      _createElementVNode("code", _hoisted_9, _toDisplayString(ep.url), 1)
                    ]),
                    _createElementVNode("p", _hoisted_10, _toDisplayString(ep.events.length === 0 ? 'Tous les événements' : ep.events.join(', ')), 1),
                    _createElementVNode("div", _hoisted_11, [
                      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-xs text-gray-500" }, "Secret de signature :", -1)),
                      (visibleSecrets.value[ep.id])
                        ? (_openBlock(), _createElementBlock("code", _hoisted_12, _toDisplayString(ep.secret), 1))
                        : (_openBlock(), _createElementBlock("code", _hoisted_13, "whsec_••••••••")),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (visibleSecrets.value[ep.id] = !visibleSecrets.value[ep.id]),
                        class: "text-xs text-[#8C0004] hover:underline"
                      }, _toDisplayString(visibleSecrets.value[ep.id] ? 'Masquer' : 'Afficher'), 9, _hoisted_14)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (testEndpoint(ep)),
                      disabled: testingId.value === ep.id,
                      class: "px-3 py-1.5 border border-gray-300 rounded-lg text-xs font-medium hover:bg-gray-50 disabled:opacity-50"
                    }, _toDisplayString(testingId.value === ep.id ? 'Envoi...' : 'Tester'), 9, _hoisted_16),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (toggleActive(ep)),
                      class: "px-3 py-1.5 border border-gray-300 rounded-lg text-xs font-medium hover:bg-gray-50"
                    }, _toDisplayString(ep.active ? 'Désactiver' : 'Activer'), 9, _hoisted_17),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (remove(ep)),
                      class: "px-3 py-1.5 border border-[#8C0004] text-[#8C0004] rounded-lg text-xs font-medium hover:bg-red-50"
                    }, " Supprimer ", 8, _hoisted_18)
                  ])
                ])
              ]))
            }), 128))
    ]),
    _cache[16] || (_cache[16] = _createElementVNode("h3", { class: "font-semibold text-gray-900 mb-4" }, "Derniers envois", -1)),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("table", _hoisted_21, [
          _cache[11] || (_cache[11] = _createElementVNode("thead", { class: "bg-gray-50 border-b border-gray-200" }, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" }, "Événement"),
              _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" }, "Statut"),
              _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" }, "Tentatives"),
              _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" }, "Réponse"),
              _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" }, "Date"),
              _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" }, "Actions")
            ])
          ], -1)),
          _createElementVNode("tbody", _hoisted_22, [
            (deliveries.value.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [...(_cache[10] || (_cache[10] = [
                  _createElementVNode("td", {
                    colspan: "6",
                    class: "px-6 py-12 text-center text-gray-500"
                  }, " Aucun envoi pour l'instant. ", -1)
                ]))]))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(deliveries.value, (w) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: w.id,
                    class: "hover:bg-gray-50"
                  }, [
                    _createElementVNode("td", _hoisted_24, [
                      _createElementVNode("code", _hoisted_25, _toDisplayString(w.eventType), 1)
                    ]),
                    _createElementVNode("td", _hoisted_26, [
                      _createElementVNode("span", {
                        class: _normalizeClass(['px-3 py-1 rounded-full text-xs font-semibold', deliveryStatusClass(w.status)])
                      }, _toDisplayString(deliveryStatusLabel(w.status)), 3)
                    ]),
                    _createElementVNode("td", _hoisted_27, _toDisplayString(w.attemptCount), 1),
                    _createElementVNode("td", _hoisted_28, [
                      (w.lastStatusCode)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, "HTTP " + _toDisplayString(w.lastStatusCode), 1))
                        : (w.lastError)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(w.lastError), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_31, "—"))
                    ]),
                    _createElementVNode("td", _hoisted_32, _toDisplayString(formatDate(w.createdAt)), 1),
                    _createElementVNode("td", _hoisted_33, [
                      (w.status !== 'SUCCESS')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: ($event: any) => (retry(w)),
                            class: "px-3 py-1 border border-gray-300 rounded text-xs font-medium hover:bg-gray-50"
                          }, " Renvoyer ", 8, _hoisted_34))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
          ])
        ])
      ])
    ]),
    (showModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4",
          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (showModal.value = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "text-lg font-bold text-gray-900" }, "Nouvel endpoint webhook", -1)),
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = false)),
                class: "text-gray-400 hover:text-gray-600"
              }, [
                _createVNode(_unref(Icon), {
                  icon: "solar:close-circle-bold",
                  class: "w-6 h-6"
                })
              ])
            ]),
            _createElementVNode("form", {
              onSubmit: _withModifiers(create, ["prevent"]),
              class: "p-6 space-y-4"
            }, [
              _createElementVNode("div", null, [
                _cache[13] || (_cache[13] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "URL de destination", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.url) = $event)),
                  type: "url",
                  required: "",
                  placeholder: _unref(modeStore).isLive ? 'https://votre-domaine.com/webhooks/youdego' : 'https://…',
                  class: "w-full rounded-lg border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#8C0004]"
                }, null, 8, _hoisted_37), [
                  [_vModelText, form.value.url]
                ]),
                (_unref(modeStore).isLive)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_38, " En production, seules les URL HTTPS sont acceptées. "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, " Événements souscrits ", -1)),
                _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-xs text-gray-500 mb-3" }, " Ne rien cocher revient à tout recevoir. ", -1)),
                _createElementVNode("div", _hoisted_39, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(EVENT_TYPES), (evt) => {
                    return (_openBlock(), _createElementBlock("label", {
                      key: evt,
                      class: "flex items-center gap-2 cursor-pointer"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        value: evt,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.events) = $event)),
                        class: "rounded border-gray-300 text-[#8C0004] focus:ring-[#8C0004]"
                      }, null, 8, _hoisted_40), [
                        [_vModelCheckbox, form.value.events]
                      ]),
                      _createElementVNode("code", _hoisted_41, _toDisplayString(evt), 1)
                    ]))
                  }), 128))
                ])
              ]),
              (error.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _createElementVNode("p", _hoisted_43, _toDisplayString(error.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (showModal.value = false)),
                  class: "flex-1 px-4 py-2.5 border border-gray-300 rounded-lg text-sm font-medium hover:bg-gray-50"
                }, " Annuler "),
                _createElementVNode("button", {
                  type: "submit",
                  disabled: !form.value.url || saving.value,
                  class: "flex-1 px-4 py-2.5 bg-[#8C0004] text-white rounded-lg text-sm font-medium hover:bg-red-900 disabled:opacity-50"
                }, _toDisplayString(saving.value ? 'Création...' : 'Créer'), 9, _hoisted_45)
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})